export function handleGetSecao(anexo: string) {

    switch (anexo) {
        case "1":
            return ([
                { "cod": "1.1", "descricao": "Seção I - Receitas decorrentes da revenda de mercadorias não sujeitas a substituição tributária, exceto as receitas decorrentes da revenda de mercadorias para exportação" },
                { "cod": "1.2", "descricao": "Seção II - Receitas decorrentes da revenda de mercadorias sujeitas a substituição tributária, exceto as receitas decorrentes da revenda de mercadorias para exportação" },
                { "cod": "1.3", "descricao": "Seção III - Receitas decorrentes da revenda de mercadorias para exportação" }
            ])
        case "2":
            return ([
                { "cod": "2.1", "descricao": "Seção I - Receitas decorrentes da venda de mercadorias por elas industrializadas não sujeitas a substituição tributária, exceto as receitas decorrentes de exportação" },
                { "cod": "2.2", "descricao": "Seção II - Receitas decorrentes da venda de mercadorias por elas industrializadas sujeitas a substituição tributária, exceto as receitas decorrentes de exportação" },
                { "cod": "2.3", "descricao": "Seção III - Receitas decorrentes da venda de mercadorias por elas industrializadas para exportação" },
                { "cod": "2.4", "descricao": "Seção IV - Receitas decorrentes de atividades com incidência simultânea de IPI e de ISS, exceto para exportação" },
                { "cod": "2.5", "descricao": "Seção V - Receitas decorrentes de atividades com incidência simultânea de IPI e de ISS para exportação" }
            ])
        case "3":
            return ([
                { "cod": "3.1", "descricao": "Seção I - Receitas decorrentes da Locação de bens móveis" },
                { "cod": "3.2", "descricao": "Seção II - Receitas decorrentes de Locação de Bens Móveis e de Prestação de Serviços Relacionados no Inciso III e V do § 1º do art. 25 da Resolução CGSN nº 140, de 2018" },
                { "cod": "3.3", "descricao": "Seção III - Receitas decorrentes de Locação de Bens Móveis e de Prestação de Serviços Relacionados no Inciso III e V do § 1º do art. 25 da Resolução CGSN nº 140, de 2018" },
                { "cod": "3.4", "descricao": "Seção IV - Receitas decorrentes de Locação de Bens Móveis e de Prestação de Serviços Relacionados no Inciso III e V do § 1º do art. 25 da Resolução CGSN nº 140, de 2018" },
                { "cod": "3.5", "descricao": "Seção V - Receitas decorrentes da prestação de serviços de comunicação, de transporte intermunicipal e interestadual de e carga, e de transporte intermunicipal e interestadual de passageiros autorizados no inciso VI do art. 17 da LC123, exceto para o exterior" },
                { "cod": "3.6", "descricao": "Seção VI - Receitas decorrentes da Prestação do Serviço de Escritórios de Serviços Contábeis Previsto no Inciso VIII do §1º do art. 25, observado o disposto no § 11 do art. 25 da Resolução CGSN nº 140, de 2018" },
                { "cod": "3.7", "descricao": "Seção VII - Receitas decorrentes da prestação de serviços para exportação" },
                { "cod": "3.8", "descricao": "Seção VIII - Receitas decorrentes da prestação de serviços de transportes intermunicipais e interestaduais de cargas e de comunicação para exportação" },
                { "cod": "3.9", "descricao": "Seção IX - Receitas decorrentes de serviços da área da construção civil relacionados no subitem 7.02 e 7.05 da lista anexa à LC 116/2003" },
                { "cod": "3.10", "descricao": "Seção X - Receitas decorrentes de serviços de transporte coletivo municipal rodoviário, metroviário, ferroviário e aquaviário de passageiros" }
            ])
        case "4":
            return ([
                { "cod": "4.1", "descricao": "Seção I - Receitas decorrentes da prestação de serviços relacionados no inciso IV do § 1º do art. 25 da Resolução CGSN nº 140, de 2018, sem retenção ou substituição tributária, com ISS devido a outro Município" },
                { "cod": "4.2", "descricao": "Seção II - Receitas decorrentes da prestação de serviços relacionados no inciso IV do § 1º do art. 25 da Resolução CGSN nº 140, de 2018, sem retenção ou substituição tributária, com ISS devido ao próprio município" },
                { "cod": "4.3", "descricao": "Seção III - Receitas decorrentes da prestação de serviços relacionados no inciso IV do § 1º do art. 25 da Resolução CGSN nº 140, de 2018, com retenção ou com substituição tributária do ISS" },
                { "cod": "4.4", "descricao": "Seção IV - Receitas decorrentes da prestação de serviços para exportação" },
                { "cod": "4.5", "descricao": "Seção V - Receitas decorrentes de serviços da área da contrução civil relacionados no subitem 7.02 e 7.05 da lista anexa à LC 116/2003" }
            ])
        case "5":
            return ([
                { "cod": "5.1", "descricao": "Seção I - Receitas decorrentes da prestação de serviços" }
            ])
        default:
            return ([])
    }
}


export function handleGetTabela(secao: string) {

    switch (secao) {
        case "1.1":
            return ([
                { cod: "1.1.1", descricao: "Tabela 1 - Sem substituição tributária" }
            ])
        case "1.2":
            return ([
                { cod: "1.2.1", descricao: "Tabela 1 - Substituição tributária do ICMS" },
                { cod: "1.2.2", descricao: "Tabela 2 - Substituição tributária do PIS/PASEP e do ICMS" },
                { cod: "1.2.3", descricao: "Tabela 3 - Substituição tributária da COFINS e do ICMS" },
                { cod: "1.2.4", descricao: "Tabela 4 - Substituição tributária da COFINS, do PIS/PASEP e do ICMS" },
                { cod: "1.2.5", descricao: "Tabela 5 - Substituição tributária somente do PIS/PASEP" },
                { cod: "1.2.6", descricao: "Tabela 6 - Substituição tributária somente da COFINS" },
                { cod: "1.2.7", descricao: "Tabela 7 - Substituição tributária somente do PIS/PASEP e da COFINS" }
            ])
        case "1.3":
            return ([
                { cod: "1.3.1", descricao: "Tabela 1 - Revenda de mercadorias para exportação" }
            ])
        case "2.1":
            return ([
                { cod: "2.1.1", descricao: "Tabela 1 - Sem substituição tributária" }
            ])
        case "2.2":
            return ([
                { cod: "2.2.1", descricao: "Tabela 1 - Substituição tributária somente do IPI" },
                { cod: "2.2.2", descricao: "Tabela 2 - Substituição tributária do IPI e do ICMS" },
                { cod: "2.2.3", descricao: "Tabela 3 - Substituição tributária Somente do IPI e do PIS/PASEP" },
                { cod: "2.2.4", descricao: "Tabela 4 - Substituição tributária do IPI e da COFINS" },
                { cod: "2.2.5", descricao: "Tabela 5 - Substituição tributária Somente do IPI, do PIS/PASEP e da COFINS" },
                { cod: "2.2.6", descricao: "Tabela 6 - Substituição tributária do IPI, do ICMS e do PIS/PASEP" },
                { cod: "2.2.7", descricao: "Tabela 7 - Substituição tributária do IPI, do ICMS e da COFINS" },
                { cod: "2.2.8", descricao: "Tabela 8 - Substituição tributária do IPI, do ICMS, do PIS/PASEP e da COFINS" },
                { cod: "2.2.9", descricao: "Tabela 9 - Substituição tributária somente do ICMS" },
                { cod: "2.2.10", descricao: "Tabela 10 - Substituição tributária do ICMS e do PIS/PASEP" },
                { cod: "2.2.11", descricao: "Tabela 11 - Substituição tributária do ICMS e da COFINS" },
                { cod: "2.2.12", descricao: "Tabela 12 - Substituição tributária do ICMS, do PIS/PASEP e da COFINS" },
                { cod: "2.2.13", descricao: "Tabela 13 - Substituição tributária Somente do PIS/PASEP" },
                { cod: "2.2.14", descricao: "Tabela 14 - Substituição tributária do PIS/PASEP e da COFINS" },
                { cod: "2.2.15", descricao: "Tabela 15 - Substituição tributária somente da COFINS" }
            ])
        case "2.3":
            return ([
                { cod: "2.3.1", descricao: "Tabela 1 - Venda de mercadorias por elas industrializadas para exportação" }
            ])
        case "2.4":
            return ([
                { cod: "2.4.1", descricao: "Tabela 1 - Receitas decorrentes de atividades com incidência simultânea de IPI e de ISS, Sem retenção/substituição tributária de ISS, com ISS devido a outro(s) Município(s)" },
                { cod: "2.4.2", descricao: "Tabela 2 - Receitas decorrentes de atividades com incidência simultânea de IPI e de ISS, Sem retenção/substituição tributária de ISS, com ISS devido ao próprio Município do estabelecimento" },
                { cod: "2.4.3", descricao: "Tabela 3 - Receitas decorrentes de atividades com incidência simultânea de IPI e de ISS, Com retenção/substituição tributária de ISS e IPI" },
                { cod: "2.4.4", descricao: "Tabela 4 - Receitas decorrentes de atividades com incidência simultânea de IPI e de ISS, Com retenção/substituição tributária de ISS" },
                { cod: "2.4.5", descricao: "Tabela 5 - Receitas decorrentes de atividades com incidência simultânea de IPI e de ISS, Com retenção/substituição tributária de IPI" }
            ])
        case "2.5":
            return ([
                { cod: "2.5.1", descricao: "Tabela 1 - Receitas decorrentes de atividades com incidência simultânea de IPI e de ISS para exportação" }
            ])
        case "3.1":
            return ([
                { cod: "3.1.1", descricao: "Tabela 1 - Locação de bens móveis, exceto para exportação" },
                { cod: "3.1.2", descricao: "Tabela 2 - Locação de bens móveis, para exportação" }
            ])
        case "3.2":
            return ([
                { cod: "3.2.1", descricao: "Tabela 1 - Sujeitos ao fator 'r' - Sem retenção ou substituição tributária, com ISS devido a outro Município" },
                { cod: "3.2.2", descricao: "Tabela 2 - Não sujeitos ao fator 'r' - Sem retenção ou substituição tributária, com ISS devido a outro Município" }
            ])
        case "3.3":
            return ([
                { cod: "3.3.1", descricao: "Tabela 1 - Sujeitos ao fator 'r' - Sem retenção ou substituição tributária, com ISS devido ao próprio Município" },
                { cod: "3.3.2", descricao: "Tabela 2 - Não sujeitos ao fator 'r' - Sem retenção ou substituição tributária, com ISS devido ao próprio Município" }
            ])
        case "3.4":
            return ([
                { cod: "3.4.1", descricao: "Tabela 1 - Sujeitos ao fator 'r' - Com retenção ou substituição tributária do ISS" },
                { cod: "3.4.2", descricao: "Tabela 2 - Não sujeitos ao fator 'r' - Com retenção ou substituição tributária do ISS" }
            ])
        case "3.5":
            return ([
                { cod: "3.5.1", descricao: "Tabela 1 - Serviços de transportes sem substituição tributária de ICMS" },
                { cod: "3.5.2", descricao: "Tabela 2 - Serviços de transportes com substituição tributária de ICMS" },
                { cod: "3.5.3", descricao: "Tabela 3 - Serviços de comunicação sem substituição tributária de ICMS" },
                { cod: "3.5.4", descricao: "Tabela 4 - Serviços de comunicação com substituição tributária de ICMS" }
            ])
        case "3.6":
            return ([
                { cod: "3.6.1", descricao: "Tabela 1 - Escritórios de serviços contábeis, exceto para exportação" },
                { cod: "3.6.2", descricao: "Tabela 2 - Escritórios de serviços contábeis, para exportação" }
            ])
        case "3.7":
            return ([
                { cod: "3.7.1", descricao: "Tabela 1 - Sujeitos ao fator 'r' - Prestação de serviços para exportação" },
                { cod: "3.7.2", descricao: "Tabela 2 - Não sujeitos ao fator 'r' - Prestação de serviços para exportação" }
            ])
        case "3.8":
            return ([
                { cod: "3.8.1", descricao: "Tabela 1 - Serviços de transportes para exportação" },
                { cod: "3.8.2", descricao: "Tabela 2 - Serviços de comunicação para exportação" }
            ])
        case "3.9":
            return ([
                { cod: "3.9.1", descricao: "Tabela 1 - Sem retenção ou substituição tributária de ISS, com ISS devido a outro Município" },
                { cod: "3.9.2", descricao: "Tabela 2 - Sem retenção ou substituição tributária de ISS, com ISS devido ao próprio Município" },
                { cod: "3.9.3", descricao: "Tabela 3 - Com retenção ou com substituição tributária de ISS" },
                { cod: "3.9.4", descricao: "Tabela 4 - Prestação de serviços para exportação" }
            ])
        case "3.10":
            return ([
                { cod: "3.10.1", descricao: "Tabela 1 - Sem retenção ou substituição tributária de ISS, com ISS devido a outro Município" },
                { cod: "3.10.2", descricao: "Tabela 2 - Sem retenção ou substituição tributária de ISS, com ISS devido ao próprio Município" },
                { cod: "3.10.3", descricao: "Tabela 3 - Com retenção ou com substituição tributária de ISS" }
            ])
        case "4.1":
            return ([
                { cod: "4.1.1", descricao: "Tabela 1 - Sem retenção ou substituição tributária, com ISS devido a outro Município" }
            ])
        case "4.2":
            return ([
                { cod: "4.2.1", descricao: "Tabela 1 - Sem retenção ou substituição tributária, com ISS devido ao próprio Município" }
            ])
        case "4.3":
            return ([
                { cod: "4.3.1", descricao: "Tabela 1 - Com retenção ou com substituição tributária do ISS" }
            ])
        case "4.4":
            return ([
                { cod: "4.4.1", descricao: "Tabela 1 - Prestação de serviços para exportação" }
            ])
        case "4.5":
            return ([
                { cod: "4.5.1", descricao: "Tabela 1 - Sem retenção ou substituição tributária de ISS, com ISS devido a outro Município" },
                { cod: "4.5.2", descricao: "Tabela 2 - Sem retenção ou substituição tributária de ISS, com ISS devido ao próprio Município" },
                { cod: "4.5.3", descricao: "Tabela 3 - Com retenção ou com substituição tributária de ISS" },
                { cod: "4.5.4", descricao: "Tabela 4 - Prestação de serviços para exportação" }
            ])
        case "5.1":
            return ([
                { cod: "5.1.1", descricao: "Tabela 1 - Sem retenção/substituição tributária de ISS, com ISS devido ao próprio município" },
                { cod: "5.1.2", descricao: "Tabela 2 - Sem retenção/substituição tributária de ISS, com ISS devido a outro município" },
                { cod: "5.1.3", descricao: "Tabela 3 - Com retenção/substituição tributária de ISS" },
                { cod: "5.1.4", descricao: "Tabela 4 - Prestação de serviços para exportação" }
            ])
        default:
            return ([])
    }
}